import React from 'react'
import { AddPenalty } from '~/features/Penalty/AddPenalty'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { PageContainer, Container, PageTitle } from '~/shared/ui/Layout'

const breadcrumbs: BreadcrumbsList = [
  { title: 'Штрафы', link: '/penalties' },
  { title: 'Создание штрафа' },
]

export function AddPenaltyPage() {
  return (
    <PageContainer title='Создание штрафа'>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>Создание штрафа</PageTitle>
      </Container>

      <AddPenalty />
    </PageContainer>
  )
}
